import * as React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import clsx from "clsx";
import moment from "moment";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Card from "@mui/material/Card";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axiosRequest from "../../api/axios";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";
import TableStyle from "../Helpers/TableStyle";
import { fontStyle } from "@mui/system";
import Header from "../Reusables/Header";
import SnackBarComponent from "../Helpers/SnackBarComponent";
import CircularProgress from "@mui/material/CircularProgress";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { toHaveValue } from "@testing-library/jest-dom/dist/matchers";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles1 = makeStyles(TableStyle);

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles({
  tableRow: {
    height: 30,
  },
  tableCell: {
    padding: "0px 16px",
  },
});
const theme = createTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#b53622",
    },
    secondary: {
      // This is green.A700 as hex.
      main: "#b53622",
    },
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.secondary.main,
    // color: theme.palette.common.white,
    paddingLeft: 10,
    paddingRight: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:nth-of-type(odd)': {
//     backgroundColor: theme.palette.action.hover,
//   },
//   // hide last border
//   '&:last-child td, &:last-child th': {
//     border: 0,
//   },
// }));
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className="admin-table-sticky">
      <TableRow
        sx={{
          "& th": {
            color: "#393b3a",
            backgroundColor: "#ebedeb",
            fontWeight: "bold",
            fontSize: "12px",
          },
        }}
      >
        {/* <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell> */}
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align="left"
            padding="normal"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              style={{
                width: headCell.width,
                maxHeight: "60px",
                minHeight: "30px",
              }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.array.isRequired,
};

export default function RephqSelectionTable() {
  const classes = useStyles1();

  const [isFilePicked, setIsFilePicked] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [order, setOrder] = React.useState("asc");
  const [editingIndex, setEditingIndex] = React.useState();
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  //   const [headcells, setHeadCells] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [file, setFile] = React.useState("");
  const [abmname, setAbmname] = React.useState("");
  const [abmcode, setAbmcode] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emails, setEmails] = React.useState([]);
  const [filters, setFilters] = React.useState([]);
  const [abmnamefilters, setAbmnameFilters] = React.useState([]);
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [loaderUpload, setloaderUpload] = useState(false);
  const [loaderDownload, setloaderDownload] = useState(false);
  const [selectedEditRow, setSelectedEditRow] = React.useState({});
  const [openDel, setOpenDel] = React.useState(false);
  const [openAbm, setOpenAbm] = React.useState(false);
  const [exist, setExist] = React.useState(false);
  const [errormsg, setErrormsg] = React.useState("");
  const [selectedDeleteId, setSelectedDeleteId] = React.useState("");
  const [effStartDate, setEffStartDate] = React.useState(null);
  const [effEndDate, setEffendDate] = React.useState(null);
  const [ActionDate, setActionDate] = React.useState(null);
  const [newUsereffStartDate, setNewUserEffStartDate] = React.useState(null);
  const [newUsereffEndDate, setNewUserEffendDate] = React.useState(null);
  const [newUserActionDate, setNewUserActionDate] = React.useState(null);
  const [editReady, setEditReady] = React.useState(false);

  const headcells = [
    {
      id: 1,
      numeric: true,
      disablePadding: false,
      label: "ID",
      width: "30px",
    },
    {
      id: 2,
      numeric: true,
      disablePadding: false,
      label: "Rephq code",
      width: "220px",
    },
    {
      id: 3,
      numeric: false,
      disablePadding: false,
      label: "Rephq name",
      width: "220px",
    },
    {
      id: 4,
      numeric: false,
      disablePadding: false,
      label: "Email",
      width: "350px",
    },
    {
      id: 5,
      numeric: false,
      disablePadding: false,
      label: "Effective Start Date",
      width: "300px",
    },
    {
      id: 6,
      numeric: false,
      disablePadding: false,
      label: "Effective End Date",
      width: "300px",
    },
    {
      id: 7,
      numeric: false,
      disablePadding: false,
      label: "Action Date",
      width: "300px",
    },
    {
      id: 8,
      numeric: false,
      disablePadding: false,
      label: "Actions",
      width: "50px",
    },
  ];
  const api_headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("Token"),
  };

  const handleClickOpenDel = async () => {
    await submitDelete(selectedDeleteId);
    await handleCloseDel();
    await gettabledata();
  };
  const handleClickOpenAbm = async () => {
    // submitDelete(selectedDeleteId)
    if (!email.includes("gsk.com")) {
        setExist(true);
        setErrormsg("Not a GSK mail");
      }
      else{
        if(abmcode=="" || newUsereffStartDate==null || newUsereffEndDate==null || newUserActionDate==null){
          handleSnackBar("Please fill All values", "error");
        }
        else{
          // console.log("else",newUsereffStartDate)
        await submitSave();
        }
      }
    
    handleCloseAbm();
    gettabledata()
  };
 
  const onchangeONE = (event, values) => {
    // submitDelete(selectedDeleteId)
    // console.log(values, "on");
    setAbmcode(values)
    for(let item of filters){
        if(item['repcode'] === values){
            setAbmname(item['rephq'])
            setAbmnameFilters([item['rephq']])
        }
    }
    

    // gettabledata()
  };
  const onchangeABMCode = (event, values) => {
    // submitDelete(selectedDeleteId)
    // console.log(values, "on");
    setAbmname(values);
    // for(let item of filters){
    //     if(item['abmcode'] === values){
    //         setAbmname(item['abmname'])
    //     }
    // }
    // gettabledata()
  };
  const onchangeEmali = (event) => {
    // submitDelete(selectedDeleteId)
    setExist(false);
    // console.log(event.target.value, "on");
    let value = event.target.value;
    for (let item of emails) {
      if (item === value) {
        setExist(true);
        setErrormsg("Email Already Exist");
      }
    }
    if (!exist) {
      setEmail(event.target.value);
    }
    // gettabledata()
  };

  const handleCloseDel = () => {
    setOpenDel(false);
  };
  const handleCloseAbm = () => {
    setOpenAbm(false);
  };
  const handleClose = () => {
    setOpensb(false);
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  function setdates(){
    let dates_list=[]
    let temp_one_date = ''
    let temp_two_date = ''
    if (localStorage.getItem('quarter') === "Q1") {
      temp_one_date = moment(localStorage.getItem('year')+"-01-01").format("YYYY-MM-DD")
      temp_two_date = moment(localStorage.getItem('year')+"-03-31").format("YYYY-MM-DD")
    } 
    if (localStorage.getItem('quarter') === "Q2") {
      temp_one_date = moment(localStorage.getItem('year')+"-04-01").format("YYYY-MM-DD")
      temp_two_date = moment(localStorage.getItem('year')+"-06-30").format("YYYY-MM-DD")     
    } if (localStorage.getItem('quarter') === "Q3") {
      temp_one_date = moment(localStorage.getItem('year')+"-07-01").format("YYYY-MM-DD")
      temp_two_date = moment(localStorage.getItem('year')+"-09-30").format("YYYY-MM-DD")   
    } if (localStorage.getItem('quarter') === "Q4") {
      temp_one_date = moment(localStorage.getItem('year')+"-10-01").format("YYYY-MM-DD")
      temp_two_date = moment(localStorage.getItem('year')+"-12-31").format("YYYY-MM-DD")
      
      // setNewUserEffStartDate(moment(year+"-10-01").format("YYYY-MM-DD"));
      // setNewUserEffendDate(moment(year+"-12-31").format("YYYY-MM-DD"));
    }
    dates_list.push(temp_one_date)
    dates_list.push(temp_two_date)
    return dates_list
  }
  useEffect(() => {
    gettabledata();
    setNewUserActionDate(new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-"+new Date().getDate())
    //logic to display month name based on Quarter
    
  }, []);
  //   let table_data_url = "admin_app/tabledata/" + table;
  const gettabledata = async () => {
    setLoader(true);
    await axiosRequest({
      url: "admin_app/rephqselection",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: localStorage.getItem('teamcode'),
        email:localStorage.getItem('email'),
        abmcode:localStorage.getItem('abmcode')
      },
    }).then((data) => {
      if (data.status === 200) {
        // setHeadCells(data?.data?.headers);
        setRows(data?.data?.data?.data);
        setEmails(data?.data?.data?.emails);
        setFilters(data?.data?.data?.filters);
        setLoader(false);
      } else {
        handleSnackBar("Unable to load the data", "error");
        setLoader(false);
      }
    });
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const downloadDuplicates = async () => {
    // setloaderDownload(true);
    let temp_dates = setdates()
    setNewUserEffStartDate(temp_dates[0]);
    setNewUserEffendDate(temp_dates[1]);
    setOpenAbm(true);
  };

  const [LoaderSave, setLoaderSave] = React.useState(false);
  const submitSave = async () => {
    setLoaderSave(true);
      await axiosRequest({
        url: "admin_app/rephqselectionuser",
        method: "POST",
        data: {
          teamcode: localStorage.getItem("teamcode"),
          email: email,
          admin_email: localStorage.getItem("email"),
          abmcode:localStorage.getItem('abmcode'),
          effective_start_date:moment(newUsereffStartDate).format('yyyy-MM-DD'),
          effective_end_date:moment(newUsereffEndDate).format('yyyy-MM-DD'),
          action_date:newUserActionDate,
          hq_code:abmcode,
          
        },
        headers: api_headers,
      }).then((data) => {
        if (data.status === 200) {
          setLoader(false);
          handleSnackBar("Data Saved Successfully", "success");
          // setadjustedTotalBrandSum(data?.data?.totm1unadj)
          // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
          // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
          setLoaderSave(false);
          setOpenDel(false);
        } else {
          setLoader(false);
          handleSnackBar("Something went wrong", "error");
          setLoaderSave(false);
          
        }
      });
  };

  const handleSubmission = async () => {
    setLoaderSave(true);
      await axiosRequest({
        url: "bu_head_app/rephqtrigger/",
        method: "POST",
        data: {
          teamcode: localStorage.getItem("teamcode"),
          email:localStorage.getItem("email"),
          year: localStorage.getItem("year"),
          quarter: localStorage.getItem("quarter"),
        },
        headers: api_headers,
      }).then((data) => {
        if (data.status === 200) {
          setLoader(false);
          handleSnackBar("Email Sent Successfully", "success");
          // setadjustedTotalBrandSum(data?.data?.totm1unadj)
          // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
          // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
          setLoaderSave(false);
          setOpenDel(false);
        } else {
          setLoader(false);
          handleSnackBar("Something went wrong", "error");
          setLoaderSave(false);
          
        }
      });
  };

  const submitEdit = async () => {
    await axiosRequest({
      url: "admin_app/rephqselectionedit",
      method: "POST",
      data: {
        data: selectedEditRow,
      },
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        handleSnackBar("Data Saved Successfully", "success");
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoader(false);
        handleSnackBar("Something went wrong", "error");
      }
    });
  };
  const [LoaderDelete, setLoaderDelete] = React.useState(false);
  const submitDelete = async (value) => {
    setLoaderDelete(true);
    await axiosRequest({
      url: "admin_app/userdelete",
      method: "POST",
      data: {
        email: value,
      },
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        handleSnackBar("Data Saved Successfully", "success");
        setLoaderDelete(false);
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoader(false);
        handleSnackBar("Something went wrong", "error");
        setLoaderDelete(false);
      }
    });
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const handleEdit = (event, row) => {
    setEditingIndex(row.id);
    setEffStartDate(row["effective_start_date"]);
    setEffendDate(row["effective_end_date"]);
    setActionDate(row["action_date"]);
    setSelectedEditRow(row);
    // console.log("edit", event, row.id);
  };
  const handleEditClose = (event, id) => {
    setEditingIndex(0);
    // console.log("edit close", event, id);
  };
  const handleEditSave = async (event, id) => {
    // console.log(selectedEditRow);
    setEditReady(true);
    let check = 0;
    selectedEditRow["effective_start_date"] =
      moment(effStartDate).format("YYYY-MM-DD") + "T00:00:00.000Z";
    selectedEditRow["effective_end_date"] =
      moment(effEndDate).format("YYYY-MM-DD") + "T00:00:00.000Z";
    selectedEditRow["action_date"] =
      moment(ActionDate).format("YYYY-MM-DD") + "T00:00:00.000Z";

    for (const [key, value] of Object.entries(selectedEditRow)) {
      // console.log(key, value);
      if (value === "") {
        check = check + 1;
      }
    }
    if (check <= 0) {
      await submitEdit();
      await gettabledata();
      setEditingIndex(0);
      setEditReady(false);
    } else {
      setEditReady(false);
      handleSnackBar("Please Fill All Values", "error");
    }
    // console.log("edit save", event, id,selectedEditRow);
  };
  const handleDelete = (event, email) => {
    // console.log("delete", event, id);
    setOpenDel(true);
    setSelectedDeleteId(email);
  };
  const inputChangeHandler = (event, value, id, key) => {
    selectedEditRow[key] = event.target.value;
    // console.log("inputChangeHandler", event.target.value, value, id, key);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Box sx={{ width: "100%" }} className="admin-tables">
      {loader === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100vh",
          }}
        >
          <CircularProgress color="inherit" display={loader.toString()} />
        </div>
      ) : (
        <Paper sx={{ width: "100%", mb: 2 }}>
          {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
          <div
            style={{
              textAlign: "right",
              padding: "10px",
              backgroundColor: "tranparent",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {/* <label
        for="countries"
        class="block  mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
      >
        Upload file 
      </label> */}

            {/* <button
          style={{ fontSize: 12 }}
          onClick={handleSubmission}
          type="button"
          class="focus:outline-none text-white bg-green-600 hover:bg-green-800 focus:ring-green-300 font-small rounded-lg text-sm px-5 py-1 mt-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
        >
          Upload
        </button> */}

            <ThemeProvider theme={theme}>
              {/* <Button sx={{color:"black"}} color="secondary" variant="contained" component="label" startIcon={<FileUploadIcon />}>
            Upload
            <input hidden accept=".csv"  type="file" onChange={changeHandler}/>
        </Button> */}

              <p style={{ fontWeight: "550" }}>REPHQ Selection</p>
              {/* <span style={{ textAlign:"left",color: "#FD7D21" }}>BUDGET DISSEMINATION TOOL - <span style={{ color: "black" }}>{table.replace("_"," ").toUpperCase()}</span></span> */}

              <div>
              <Button
                style={{
                  backgroundColor: "#FF6A0A",
                  color: "white",
                  textTransform: "none",
                }}
                  onClick={handleSubmission}
                  type="button"
                  >
                 Send Mail
              </Button>
                <Button
                  sx={{ ml: 1, width: "240px", height: "35px" }}
                  style={{
                    backgroundColor: "#FF6A0A",
                    color: "white",
                    textTransform: "none",
                  }}
                  variant="contained"
                  component="span"
                  startIcon={
                    <AddCircleOutlineIcon
                      style={{ display: loaderDownload ? "none" : "" }}
                      fontSize="small"
                    />
                  }
                  onClick={downloadDuplicates}
                >
                  {" "}
                  {loaderDownload == true ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: loaderDownload ? "space-between" : "",
                      }}
                    >
                      <CircularProgress
                        size="1rem"
                        color="inherit"
                        display={loaderDownload == true ? "true" : "false"}
                      />
                    </div>
                  ) : (
                    <span>Add New REPHQ Code</span>
                  )}
                </Button>
              </div>
            </ThemeProvider>
          </div>
          <TableContainer sx={{ maxHeight: 490, overflow: "auto" }}>
            <Table
              stickyHeader
              sx={{ minWidth: 600 }}
              aria-labelledby="tableTitle"
              size={dense ? "small" : "small"}
            >
              <EnhancedTableHead
                headCells={headcells}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                {stableSort(rows, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.name);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        //   hover
                        //   onClick={(event) => handleClick(event, row.name)}
                        //   role="checkbox"
                        //   aria-checked={isItemSelected}
                        //   tabIndex={-1}
                        key={row.id}
                        //   selected={isItemSelected}
                      >
                        {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell> */}
                        {/* {row.map((object, i) => <TableCell align="right" obj={object} key={i} />)} */}
                        {/* {row.map(item => <TableCell align="right" key={item.id} name={item.name} />)}  */}
                        {Object.keys(row).map((key, idx) =>
                          editingIndex === row.id ? (
                            <StyledTableCell align="left">
                              {key == "effective_start_date" ||
                              key == "effective_end_date" ||
                              key == "action_date" ? (
                                <div>
                                  {key === "effective_start_date" ? (
                                    <LocalizationProvider
                                      dateAdapter={AdapterMoment}
                                    >
                                      <DatePicker
                                        views={["day"]}
                                        value={effStartDate}
                                        format="yyyy-MM-dd"
                                        onChange={(newValue) => {
                                          // console.log(newValue, "efftfadh");
                                          setEffStartDate(newValue);
                                          // inputChangeHandler(event, newValue, row.id, key)
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            size="small"
                                            helperText={null}
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  ) : key === "effective_end_date" ? (
                                    <LocalizationProvider
                                      dateAdapter={AdapterMoment}
                                    >
                                      <DatePicker
                                        views={["day"]}
                                        value={effEndDate}
                                        onChange={(newValue) => {
                                          setEffendDate(newValue);
                                          // inputChangeHandler(event, newValue, row.id, key)
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            size="small"
                                            helperText={null}
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  ) : (
                                    <LocalizationProvider
                                      dateAdapter={AdapterMoment}
                                    >
                                      <DatePicker
                                        views={["day"]}
                                        value={ActionDate}
                                        onChange={(newValue) => {
                                          setActionDate(newValue);
                                          // inputChangeHandler(event, newValue, row.id, key)
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            size="small"
                                            helperText={null}
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  )}
                                </div>
                              ) : (
                                <TextField
                                  size="small"
                                  key={row.id}
                                  disabled={key === "id"}
                                  style={{ width: "8rem" }}
                                  onChange={(e) =>
                                    inputChangeHandler(e, row[key], row.id, key)
                                  }
                                  defaultValue={row[key]}
                                />
                              )}
                            </StyledTableCell>
                          ) : (
                            <StyledTableCell
                              align="left"
                              key={idx}
                              style={{ width: "8rem" }}
                            >
                              {key == "effective_start_date" ||
                              key == "effective_end_date" ||
                              key == "action_date"
                                ? moment(row[key]).format("L")
                                : row[key]}
                            </StyledTableCell>
                          )
                        )}
                        {/* <TableCell
                        component="th"
                        
                        id={labelId}
                        scope="row"
                        align="left"
                      >
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.calories}</TableCell>
                      <TableCell align="right">{row.fat}</TableCell>
                      <TableCell align="right">{row.carbs}</TableCell>
                      <TableCell align="right">{row.protein}</TableCell> */}
                        {editingIndex === row.id ? (
                          <StyledTableCell align="left">
                            {editReady === true ? (
                              ""
                            ) : (
                              <CloseIcon
                                sx={{ marginRight: "10px" }}
                                onClick={(event) =>
                                  handleEditClose(event, row.id)
                                }
                              />
                            )}
                            {editReady === true ? (
                              <CircularProgress
                                size="1.5rem"
                                color="success"
                                display={editReady.toString()}
                              />
                            ) : (
                              <DoneIcon
                                onClick={(event) =>
                                  handleEditSave(event, row.id)
                                }
                              />
                            )}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell align="left">
                            <ModeEditOutlineIcon
                              sx={{ marginRight: "10px" }}
                              onClick={(event) => handleEdit(event, row)}
                            />
                            <DeleteIcon
                              onClick={(event) => handleDelete(event, row.email)}
                            />
                          </StyledTableCell>
                        )}
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={4} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
      <div>
        {/* <Button variant="outlined" onClick={handleClickOpenDel}>
        Open draggable dialog
      </Button> */}
        <Dialog
          open={openDel}
          onClose={handleCloseDel}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Delete
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: "#E5E5E5",
                textTransform: "none",
                color: "black",
                height: "32px",
              }}
              autoFocus
              onClick={handleCloseDel}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "#fd7d21",
                textTransform: "none",
                color: "white",
                height: "32px",
              }}
              onClick={handleClickOpenDel}
            >
              {LoaderDelete == true ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    size="1rem"
                    color="inherit"
                    display={LoaderDelete == true ? "true" : "false"}
                  />
                </div>
              ) : (
                <span>Delete</span>
              )}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openAbm}
          onClose={handleCloseAbm}
          fullWidth
          maxWidth="lg"
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Create
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "flex",
                flexDirection:"column",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
                <div style={{display:"flex",justifyContent:"space-around"}}>
                <Autocomplete
                id="free-solo-demo"
                freeSolo
                value={abmcode}
                sx={{ width: "32%" }}
                fullWidth={true}
                onChange={onchangeONE}
                options={filters.map((option) => option.repcode)}
                renderInput={(params) => (
                  <TextField {...params} label="Rephq code" size="small" />
                )}
              />
              <Autocomplete
                freeSolo
                value={abmname}
                id="free-solo-2-demo"
                disableClearable
                sx={{ width: "32%" }}
                fullWidth={true}
                onChange={onchangeABMCode}
                options={abmnamefilters.map((option) => option)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="Rephq name"
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                    }}
                  />
                )}
              />
              <TextField
                error={exist}
                onChange={onchangeEmali}
                id="filled-error-helper-text"
                label="Email"
                helperText={exist ? errormsg : ""}
                variant="outlined"
                size="small"
                sx={{ width: "32%" }}
              /></div>
              <div style={{display:"flex",justifyContent:"space-around",marginTop: "10px",}}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  views={["day"]}
                  
                  value={newUsereffStartDate}
                  label="Start Date"
                  onChange={(newValue) => {
                    setNewUserEffStartDate(newValue);
                    // inputChangeHandler(event, newValue, row.id, key)
                  }}
                  renderInput={(params) => (
                    <TextField sx={{ width: "32%" }} {...params} size="small" helperText={null} />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  views={["day"]}
                  
                  value={newUsereffEndDate}
                  label="End Date"
                  onChange={(newValue) => {
                    setNewUserEffendDate(newValue);
                    // inputChangeHandler(event, newValue, row.id, key)
                  }}
                  renderInput={(params) => (
                    <TextField sx={{ width: "32%" }} {...params} size="small" helperText={null} />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  views={["day"]}
                  value={newUserActionDate}
                  disabled={true}
                  label="Action Date"
                  onChange={(newValue) => {
                    setNewUserActionDate(newValue);
                    // inputChangeHandler(event, newValue, row.id, key)
                  }}
                  renderInput={(params) => (
                    <TextField sx={{ width: "32%" }} {...params} size="small" helperText={null} />
                  )}
                />
              </LocalizationProvider>
              </div>
            </div>
            {/* <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText> */}
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: "#E5E5E5",
                textTransform: "none",
                color: "black",
                height: "32px",
              }}
              onClick={handleCloseAbm}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "#fd7d21",
                textTransform: "none",
                color: "white",
                height: "32px",
              }}
              autoFocus
              onClick={handleClickOpenAbm}
            >
              {LoaderSave == true ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    size="1rem"
                    color="inherit"
                    display={LoaderSave == true ? "true" : "false"}
                  />
                </div>
              ) : (
                <span>Save</span>
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
      />
    </Box>
  );
}
